import React from 'react';
import { Link } from 'react-router-dom';
import logo_heart from '../../../assets/images/heart-logo.png';
import '../../../pages/Home/Home.css';

export const Logo = ({ to = "/", className = "", style = {}, showText = true, textColor = '#111111' }) => {
    return (
        <Link 
            to={to} 
            className={`flex items-center gap-2 ${className}`} 
            style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem', ...style }}
        >
            <img src={logo_heart} alt="MTD Logo" className="nav-logo" />
            {showText && (
                <span 
                    className="lp-font-black lp-tracking-tight nav-logo-text" 
                    style={{ color: textColor }}
                >
                    myTamilDate
                </span>
            )}
        </Link>
    );
};
